export enum SortPropsPayment {
  ProviderAsc = 'providerAsc',
  ProviderDesc = 'providerDesc',
  DateAsc = 'dateAsc',
  DateDesc = 'dateDesc',
  AmountAsc = 'amountAsc',
  AmountDesc = 'amountDesc',
}

export enum SortPropsTitlePayment {
  Date = 'Date',
  Provider = 'Provider',
  Amount = 'Amount',
}